import { changeItem, getCart } from '../lib/cart';
import { lockScroll, unlockScroll } from '../utils/util-functions';

export default (node) => {
  /**
   * Data + elements
   */
  const cartDrawerEl = node;
  const cartContentWrapper = node.querySelector('[data-cart-content-wrapper]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const closeDrawerButton = node.querySelector('[data-close-drawer]');
  const cartContentLoading = node.querySelector('[data-cart-content-loading]');
  const cartListener = window;
  const cartError = node.querySelector('[data-cart-error]');

  const moneyFormat = cartDrawerEl
    .getAttribute('data-money-format')
    .replace('amount_with_dot_separator', 'amount');

  /**
   * Functions
   */

  /**
   * Update Quantity Cart Info
   * @param {*} e
   */
  const updateQuantityCartInfo = async (lineItem, newQuantity) => {
    cartContentLoading.classList.remove('hidden');
    cartContentWrapper.classList.add('overflow-y-hidden');

    // const updatedCart = await changeItem({lineItemId, 0});
    const updatedCart = await changeItem({
      key: lineItem,
      quantity: newQuantity,
    });

    cartContentLoading.classList.add('hidden');
    cartContentWrapper.classList.remove('overflow-y-hidden');
  };

  /**
   * Open cart after adding item
   */
  const openCart = async (data) => {
    // check if the current page is the main cart page to dont open the cart drawer
    if (window.location.pathname === '/cart') return;

    document.dispatchEvent(new CustomEvent('desktop-menu:close'));
    lockScroll();

    cartOverlay.classList.remove('hidden');
    cartDrawerEl.classList.add('!translate-x-0');
    cartListener.addEventListener('keydown', handleEscapeKey);
  };

  /**
   * handle Escape key to close cart drawer
   */
  const handleEscapeKey = (e) => {
    if (e.key === 'Escape') {
      closeCart();
    }
  };

  /**
   * close cart drawer
   */
  const closeCart = () => {
    cartDrawerEl.classList.remove('!translate-x-0');

    unlockScroll();

    // remove event listener for escape key
    cartListener.removeEventListener('keydown', handleEscapeKey);
    cartOverlay.classList.add('hidden');
  };

  /**
   * Reattach eventlistener
   */
  const attachEventListener = () => {
    const allItems = node.querySelectorAll('[data-cart-item]');
    allItems.forEach((item) => {
      const itemIncrease = item.querySelector('[data-cart-quantity-increase]');
      if (itemIncrease) {
        itemIncrease.addEventListener('click', () => {
          updateQuantityCartInfo(
            item.dataset.lineItemKey,
            Number(item.dataset.lineCurrentQuantity) + 1
          );
        });
      }
      const itemDecrease = item.querySelector('[data-cart-quantity-decrease]');
      if (itemDecrease) {
        itemDecrease.addEventListener('click', () => {
          updateQuantityCartInfo(
            item.dataset.lineItemKey,
            Number(item.dataset.lineCurrentQuantity) - 1
          );
        });
      }

      const itemRemove = item.querySelector('[data-cart-remove-item]');
      if (itemRemove) {
        itemRemove.addEventListener('click', () => {
          updateQuantityCartInfo(item.dataset.lineItemKey, 0);
        });
      }
    });
  };

  const showError = (message) => {
    cartContentLoading.classList.add('hidden');
    cartContentWrapper.classList.remove('overflow-y-hidden');
    cartError.textContent = message.detail;
    cartError.classList.remove('hidden');
    // close error message after 5 seconds
    setTimeout(() => {
      cartError.classList.add('hidden');
      cartError.textContent = '';
    }, 5000);
  };

  /**
   * Init
   */
  const init = () => {
    attachEventListener();

    closeDrawerButton.addEventListener('click', closeCart);

    // add event listener for cart:reattach-listener
    document.addEventListener('cart:attachListener', attachEventListener);

    // add event listener for cart:updated
    document.addEventListener('cart:updated', getCart);

    document.addEventListener('cart:error', showError);

    // add event listener for cart:open
    document.addEventListener('cart:open', openCart);

    document.addEventListener('cart:close', closeCart);

    // add event listener for body to close drawer when click outside cart or press escape key
    cartOverlay.addEventListener('click', (e) => {
      // skip when cart button on the header is press
      closeCart();
    });
  };

  init();
};
